import * as React from 'react';
import { Grid, Divider, CircularProgress } from '@material-ui/core';
import { defaultTranslateFn } from "../../../../common";
import { StyledSectionTitle } from '../../common';
import { VehicleAttribute } from './VehicleAttribute';
import { VehicleAttributesSectionEnum, VehicleAttributeTypeEnum } from '../enums';
import { StyledSectionTitleGrid } from '../styles';
/**
 *	Main component which is containing all the attributes (i.e. PIN, NADA & Redbook)
 *
 * @param isBusy [Optional] boolean - To show / hide Progress Bar
 * @param vehicleAttributes [Required] - { PinAttributes: [], NadaAttributes: [], RedbookAttributes: [] }
 * @param selectedPinVid [Required] - Vehicle Selected PinVid or null
 * @param selectedNadaVid [Required] - Vehicle selected NadaVid or null
 * @param selectedControlNumber [Required] - Redbook Attribute control number or null
 * @param onAttributeChange [Required] - Callback Method for Select input
 * @param translateFn [Optional] - Method used for translations
 */
export const VehicleAttributesSection = ({ isBusy, vehicleAttributes, selectedPinVid, selectedNadaVid, selectedControlNumber, onAttributeChange, translateFn = defaultTranslateFn }) => {
    /* Function to create Id for each attribute type */
    const getVehicleAttributeId = (attributeType) => `${attributeType}VehicleAttribute`;
    const hasPinAttributes = vehicleAttributes &&
        vehicleAttributes.pinAttributes &&
        !!vehicleAttributes.pinAttributes.length;
    const hasNadaAttributes = vehicleAttributes &&
        vehicleAttributes.nadaAttributes &&
        !!vehicleAttributes.nadaAttributes.length;
    const hasRedbookAttributes = vehicleAttributes &&
        vehicleAttributes.redbookAttributes &&
        !!vehicleAttributes.redbookAttributes.length;
    /* render Pin Attribute if PinAttributes length is greater than 0 */
    const renderPinAttribute = (hasPinAttributes && (React.createElement(VehicleAttribute, { id: getVehicleAttributeId(VehicleAttributeTypeEnum.PIN_ATTRIBUTE), attributeType: VehicleAttributeTypeEnum.PIN_ATTRIBUTE, attributes: vehicleAttributes.pinAttributes, selectedAttributeValue: selectedPinVid, onAttributeChange: onAttributeChange, translateFn: translateFn }))) ||
        undefined;
    /* render Nada Attribute if NadaAttributes length is greater than 0 */
    const renderNadaAttribute = (hasNadaAttributes && (React.createElement(VehicleAttribute, { id: getVehicleAttributeId(VehicleAttributeTypeEnum.NADA_ATTRIBUTE), attributeType: VehicleAttributeTypeEnum.NADA_ATTRIBUTE, attributes: vehicleAttributes.nadaAttributes, selectedAttributeValue: selectedNadaVid, onAttributeChange: onAttributeChange, translateFn: translateFn }))) ||
        undefined;
    /* render Redbook Attribute if RedbookAttributes length is greater than 0 */
    const renderRedbookAttribute = (hasRedbookAttributes && (React.createElement(VehicleAttribute, { id: getVehicleAttributeId(VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE), attributeType: VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE, attributes: vehicleAttributes.redbookAttributes, selectedAttributeValue: selectedControlNumber, onAttributeChange: onAttributeChange, translateFn: translateFn }))) ||
        undefined;
    /* show spinner when isBusy is true */
    if (isBusy) {
        return React.createElement(CircularProgress, null);
    }
    return (React.createElement(React.Fragment, null, (hasPinAttributes || hasNadaAttributes || hasRedbookAttributes) && (React.createElement(Grid, { container: true },
        React.createElement(StyledSectionTitleGrid, { container: true, item: true, xs: 12, direction: "column", wrap: "nowrap" },
            React.createElement(StyledSectionTitle, null, translateFn(VehicleAttributesSectionEnum.TITLE)),
            React.createElement(Divider, null)),
        renderPinAttribute,
        renderNadaAttribute,
        renderRedbookAttribute))));
};
//# sourceMappingURL=VehicleAttributesSection.js.map